import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { TaskService } from '@autoinformer/services/TaskService';
import ItemForm from '@autoinformer/components/tasks-create-form.vue';
class TaskModalService extends ModalService {
  constructor() {
    super(TaskService);
  }
  remove(path, item) {
    return this.$removeDeepItem(path, item, {
      content: i18n.t('autoinformer.task.modal.remove.content', {
        number: `<strong>${item.number}</strong>`
      })
    });
  }
  create(campaign_id) {
    return this.$open({
      title: i18n.t('shared.component.modal.create'),
      width: this.size.confirm,

      render: h =>
        h(ItemForm, {
          props: {
            campaign_id
          },
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new TaskModalService();
export { instance as TaskModalService };
